import { useState } from 'react';
import { adjust, assoc, compose, map, pick, propOr } from 'ramda';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import useSaveSimulationOfferGroupProtectionMutation from './useSaveSimulationOfferGroupProtectionMutationQuery.js';

const useSimulationOfferGroupProtectionForm = ({ getSimulationOfferGroupProtection }) => {
  const [loadingOfferIndex, setLoadingOfferIndex] = useState(null);
  const saveOffer = useSaveSimulationOfferGroupProtectionMutation();
  const { processHandlers, context } = useProcess();
  const transitionContext = { context: { projectId: context?.projectId } };

  const products = propOr([], 'products', getSimulationOfferGroupProtection);

  const $onNextClick = (selectedProducts) => {
    const input = map(pick(['code', 'name', 'isSelected', 'status']), selectedProducts);
    saveOffer.onFormSubmit({ products: input }, (ok, error) => {
      if (ok && !error) {
        processHandlers.onNext(transitionContext);
      } else {
        setLoadingOfferIndex(null);
      }
    });
  };

  // Un clic sélectionne l'offre, l'enregistre puis passe à l'étape suivante
  const updateSelectedOffer = (index) => {
    if (loadingOfferIndex !== null) return;
    setLoadingOfferIndex(index);
    const selectedProducts = compose(
      adjust(index, assoc('isSelected', true)),
      map(assoc('isSelected', false))
    )(products);
    $onNextClick(selectedProducts);
  };

  const $onPrevClick = () => {
    processHandlers.onPrev(transitionContext);
  };

  return {
    products,
    loadingOfferIndex,
    updateSelectedOffer,
    $onPrevClick
  };
};

export default useSimulationOfferGroupProtectionForm;
